// =====================================
//
//   FAQ Content Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 29
//
// =====================================

window.InifECMobileApp.controller("FAQContentController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', '$compile', 'FAQService', '$PreviousState', '$WebTitle',
	function($scope, $state, $timeout, $rootScope, $stateParams, $compile, FAQService, $PreviousState, $WebTitle) {

        // --------------------------------
        // [private] 取得某子分類所有FAQ
        // --------------------------------
        var getSubClassFAQlist = function() {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;

            FAQService.getSubClassFAQlist($scope.subfaqid).then(function(result) {

                if(result && result.length) {

                    // compile note html
                    var $raw = $('<div/>').html(result.content);
                    $raw.find('img').each(function(){
                        var src = $(this).attr('src');
                        if(src && src.startsWith("//") && location.protocol.startsWith("file")){
                            this.src = "http:" + src;
                        }
                    });

                    result.content = $compile($raw)($scope);

                    $scope.faqList = result; 
                } else {
                    $scope.isError = true;
                }

                targetFAQ();

                $scope.isLoading = false;

            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        var targetFAQ = function() {

            if(!$scope.currentfaqid || $scope.currentfaqid == '') {
                $state.go(window.STATES.FAQ);
                return;
            }

            for(var i = 0; i < $scope.faqList.length; i++) {

                if($scope.faqList[i].faqid == $scope.currentfaqid) {
                    $scope.faq = $scope.faqList[i];
                    break;
                }
            }

            $timeout(function() {
                var target = $('[data-faqid="' + $scope.currentfaqid +'"]');

                if(target.length > 0) {
                    document.body.scrollTop = document.documentElement.scrollTop = target.offset().top - 140;
                }
            })
        };

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var backState = $PreviousState.getFAQPrevious();

            $PreviousState.goBack(backState);
        }

        var init = function() {
                getSubClassFAQlist();
        };

	    //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $scope.currentfaqid = toParams.faqid;
        });

        //==========================
        //  Members
        //==========================
        $scope.mainfaqid = $stateParams.mainfaqid;
        $scope.subfaqid = $stateParams.subfaqid;

        $scope.faq = null;
        $scope.faqList = [];
        $scope.isError = false;
        $scope.isLoading = false;
        $scope.title = '';

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;
        
        //==========================
        //  Init
        //==========================
        init();
	}
]);